var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.122 15.476a1.503 1.503 0 011.756 0l5.622 4.05V4.495a.5.5 0 00-.5-.5H6a.5.5 0 00-.5.5v15.03l5.622-4.05zM12 16.69l6.415 4.62A1 1 0 0020 20.5V4.496A1.998 1.998 0 0018 2.5H6c-1.105 0-2 .893-2 1.995v16.006a1 1 0 001.585.808L12 16.69z",
    fill: "currentColor"
  })));
}
export default SvgBookmark;